<template>
  <div class="dddl-container">
    <el-row>
      <el-col class="tcf-row">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              订单代录
            </div>
            <div class="card-content">
              <el-form ref="eForm" :model="eForm" :rules="eRules" label-width="100px">
                <el-form-item label="经销商" prop="delid">
                  <el-select v-model="eForm.delid" filterable clearable style="width:400px" @change="setDel">
                    <el-option
                      v-for="item in dealerInfo"
                      :key="item.delid"
                      :label="item.allname"
                      :value="item.delid"
                    >
                      <span style="float: left">{{ item.allname }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.province }} {{ item.city }} {{ item.county }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="订单类型" prop="type">
                  <el-radio v-model="eForm.type" :label="0">正单</el-radio>
                  <el-radio v-model="eForm.type" :label="1" @change="changeType">客改单</el-radio>
                  <el-radio v-model="eForm.type" :label="2" @change="changeType">增补单</el-radio>
                  <el-radio v-model="eForm.type" :label="3" @change="changeType">色板单</el-radio>
                  <el-radio v-model="eForm.type" :label="4" @change="changeType">售后单</el-radio>
                </el-form-item>
                <!-- <el-form-item v-if="eForm.type == 4" label="是否需要收款" prop="fk">
                  <el-radio-group v-model="eForm.fk">
                    <el-radio :label="0">需要</el-radio>
                    <el-radio :label="1">不需要</el-radio>
                  </el-radio-group>
                  <div style="font-size: 13px;color:#F56C6C">
                    <i class=" el-icon-info"></i> 温馨提示：<br>
                    <span>仅售后单时，是否需要对客户进行收款。</span><br>
                  </div>
                </el-form-item> -->
                <el-form-item v-if="eForm.type!==0&&isManual===false" label="原正单" prop="oldorderid">
                  <OrderSelect :key="orderLoad" v-model="eForm.oldorderid" :disabled="eForm.delid===null||eForm.delid===''" :delid="eForm.delid" @setOrder="setOrder"></OrderSelect>
                  <el-button v-if="eForm.delid!==null&&eForm.delid!==''" type="text" icon="el-icon-edit" @click="openManual">找不到原正单，点击这里手动填写</el-button>
                </el-form-item>
                <el-form-item v-if="isManual===true&&eForm.type!==0" label="原正单" prop="delid">
                  <el-col :span="6" style="padding-right: 10px">
                    <el-form-item prop="beforenum">
                      <el-input v-model="eForm.beforenum" :disabled="eForm.delid===null||eForm.delid===''" placeholder="请输入原正单生产单号" maxlength="20"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item prop="beforeyear">
                      <el-date-picker
                        v-model="eForm.beforeyear"
                        :disabled="eForm.delid===null||eForm.delid===''"
                        type="year"
                        format="yyyy年"
                        value-format="yyyy"
                        :picker-options="pickerYear"
                        placeholder="选择原正单年份"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-button v-if="eForm.delid!==null&&eForm.delid!==''" type="text" icon="el-icon-search" @click="isManual=false">点击这里搜索原正单</el-button>
                </el-form-item>
                <el-form-item label="南北工艺" prop="nb" v-if="showNb">
                  <el-radio-group v-model="eForm.nb" size="medium">
                    <el-radio-button label="1">南</el-radio-button>
                    <el-radio-button label="2">北</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="" prop="mr">
                  <div style="font-size: 13px;color:#F56C6C">
                    <i class=" el-icon-info"></i> 温馨提示：<br>
                    <span>后续订单将以当前选择的工艺为默认值（后续仍可修改），订单后续因更改工艺造成产品的开裂、变形，由经销商自行承担售后风险。</span><br>
                  </div>
                </el-form-item> -->
                <el-form-item label="客户名称" prop="custname">
                  <el-input v-model="eForm.custname" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="客户电话" prop="custtel">
                  <el-input v-model="eForm.custtel" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="eForm.address" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="订单性质" prop="nature">
                  <el-radio v-model="eForm.nature" :label="0">家装</el-radio>
                  <!-- <el-radio v-model="eForm.nature" :label="1">展厅</el-radio> -->
                  <el-radio v-model="eForm.nature" :label="2">工程</el-radio>
                </el-form-item>
                <el-form-item label="期望交期" prop="exptime">
                  <el-date-picker
                    v-model="eForm.exptime"
                    type="date"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                  <span style="color:#99a9bf;margin-left: 10px;font-size: 12px;">至少10天以上</span>
                </el-form-item>
                <el-form-item label="品牌" prop="bid">
                  <span v-if="eForm.delid===null||eForm.delid===''" style="color:#99a9bf;">请先选择经销商</span>
                  <el-radio
                    v-for="item in brandInfo"
                    v-if="eForm.delid!==null&&eForm.delid!==''"
                    v-model="eForm.bid"
                    :label="item.bid"
                    @change="setBid"
                  >{{ item.brandname }}</el-radio>
                </el-form-item>
                <el-form-item label="设计师姓名" prop="designer">
                  <el-input v-model="eForm.designer" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="设计师电话" prop="designerTel">
                  <el-input v-model="eForm.designerTel" maxlength="11"></el-input>
                </el-form-item>
                <!--                <el-form-item label="色板来源" prop="source" >-->
                <!--                  <el-radio-group v-model="eForm.source" @change="changeradio">-->
                <!--                    <el-radio  :label="0">厂部标准色板</el-radio>-->
                <!--                    <el-radio  :label="1">客户提供色板</el-radio>-->
                <!--                    <el-radio  :label="2">厂部定制色板</el-radio>-->
                <!--                  </el-radio-group>-->
                <!--                </el-form-item>-->
                <el-form-item label="色板来源" prop="source">
                  <el-checkbox-group v-model="eForm.source" @change="changeradio">
                    <el-checkbox :label="0">厂部标准色板</el-checkbox>
                    <el-checkbox :label="1">客户提供色板</el-checkbox>
                    <el-checkbox :label="2">厂部定制色板</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-if="eForm.source && eForm.source.indexOf(0) > -1" label="厂部标准色板" prop="sids">
                <span v-if="!eForm.bid" style="color:#99a9bf;">请先选择品牌</span>
                  <el-select
                    v-else
                    style="width: 100%;"
                    v-model="eForm.sids"
                    multiple
                    filterable
                    placeholder="可输入编号/名称搜索"
                    @change="setCb">
                    <el-option
                      v-for="(item, index) in cbList"
                      :key="index"
                      :label="item.code + ' / ' + item.name + ' / ' + item.seriesname"
                      :value="item.board_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客供物料" prop="ishaveclient">
                  <el-radio v-model="eForm.ishaveclient" :label="0">无客供物料</el-radio>
                  <el-radio v-model="eForm.ishaveclient" :label="1">有客供物料</el-radio>
                  <el-select
                    v-if="eForm.ishaveclient===1"
                    v-model="eForm.client"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择或自定义物料名称"
                    @change="changeClient"
                  >
                    <el-option
                      v-for="item in clientmaterial"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="eForm.client.length>0&&eForm.ishaveclient===1">
                  <el-row v-for="item in eForm.clientInfo" :key="item.key" style="margin-bottom: 10px">
                    <el-col :span="14" style="padding-right: 6px">
                      <el-form-item>
                        <el-input v-model="item.remark" prefix-icon="el-icon-news" placeholder="物料说明" maxlength="30" show-word-limit>
                          <template slot="prepend"><span style="font-weight: bold;margin-right: 10px"><i class="el-icon-paperclip"></i> {{ item.name }}</span></template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item>
                        <el-checkbox v-model="item.type">需返还</el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item v-if="eForm.client.length>0&&eForm.ishaveclient===1">
                  <div style="font-size: 12px;color:#9aaabf">
                    <i class=" el-icon-info"></i> 温馨提示：<br>
                    <span>1、由于空气水分灯光等环境因素会导致色板变色，本着彼此负责的态度，凡超过3个月的色板请及时邮寄样品到浙江耐思迪家具有限公司;</span><br>
                    <span>2、我们的生产周期将按色板及客供物料到位后开始计算.</span>
                  </div>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="eForm.remark" type="textarea" maxlength="300" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="附属文件" prop="files">
                  <MultiFile ref="fileupload" v-model="eForm.files" style="width: 400px"></MultiFile>
                </el-form-item>
                <el-form-item label="附属图片" prop="imgids">
                  <span v-if="eImgList.length > 0" style="color:#99a9bf; font-size: 12px;">厂部标准色板图片</span>
                  <div style="display: flex; flex-wrap: wrap;">
                    <div style="width: 80px; height: 80px; margin: 0 8px 8px 0; overflow: hidden; background-color: #fff; border-radius: 6px; border: 1px solid #c0ccda;"
                      v-for="(item, index) in eImgList" :key="index">
                      <el-image style="width: 100%; height: 100%;" :src="item.url" :preview-src-list="[item.url]"></el-image>
                    </div>
                  </div>
                  <span style="color:#99a9bf; font-size: 12px;">上传其他色板照片</span>
                  <MultiImg ref="imgupload" v-model="eForm.imgids" :size="'sm'" :limit="2"></MultiImg>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="editloading" @click="onSubmit('eForm')">立即提交</el-button>
                  <el-button @click="resetForm('eForm')">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OrderSelect from '@/components/OrderSelect'
import { getUser } from '@/utils/auth'
import { getErpDealerList, getErpDealerBrandList, ErpOrderReplace, getClientMaterial } from '@/api/erp'
import { getColorBoardList } from '@/api/about/swatch'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import { validatePhoneNumber } from '@/utils/validate'
import qs from 'qs'

export default {
  name: 'Dddl',
  components: {
    OrderSelect,
    MultiFile,
    MultiImg
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validateClient = (rule, value, callback) => {
      if (value === 1 && this.eForm.client.length <= 0) {
        callback(new Error('请选择客供物料'))
      } else {
        callback()
      }
    }
    return {
      showNb: false,
      editloading: false,
      isManual: false,
      orderLoad: '',
      clientmaterial: [],
      dealerInfo: [],
      brandInfo: [],
      eForm: {
        fk: 0,
        num: 0,
        delid: '',
        type: 0,
        nature: 0,
        oldorderid: '',
        beforenum: '',
        beforeyear: '',
        custname: '',
        custtel: '',
        address: '',
        exptime: '',
        designer: '',
        designerTel: '',
        estimated: null,
        bid: null,
        nb: '',// 1-南 2-北
        mr: true,
        source: [],
        sids: [],
        remark: '',
        files: [],
        imgids: [],
        ishaveclient: 0,
        client: [],
        clientInfo: []
      },
      eRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
        ishaveclient: [{ required: true, validator: validateClient, trigger: 'change' }],
        nature: [{ required: true, message: '请选择订单性质', trigger: 'change' }],
        oldorderid: [{ required: true, message: '请选择原正单', trigger: 'change' }],
        custname: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        custtel: [{ required: true, trigger: 'blur', validator: validatePhone }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        exptime: [{ required: true, message: '请选择期望交期', trigger: 'change' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        source: [{ required: true, message: '请选择色板来源', trigger: 'change' }],
        sids: [{ required: true, message: '请选择色板', trigger: 'change' }],
        designer: [{ required: true, message: '请输入设计师姓名', trigger: 'blur' }],
        designerTel: [{ required: true, trigger: 'blur', validator: validatePhone }],
        beforenum: [{ required: true, message: '请输入原正单号', trigger: 'blur' }],
        beforeyear: [{ required: true, message: '请选择原正单年份', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传图片', trigger: 'change' }],
        nb: [{ required: true, message: '请选择南北工艺', trigger: 'change' }],
        fk: [{ required: true, message: '请选择是否需要收款', trigger: 'change' }],
      },

      cbList: [],
      cbLoading: false,
      eImgList: [],
    }
  },
  computed: {
    user: getUser,
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() + 9 * 24 * 60 * 60 * 1000
        }
      }
    },
    pickerYear() {
      return {
        disabledDate(time) {
          return time.getTime() >= Date.now()
        }
      }
    }
  },
  created() {
    this.getDealerInfoList()
    getClientMaterial().then(response => {
      this.clientmaterial = response.data
    }).catch(() => {
      this.clientmaterial = []
    })
  },
  methods: {
    changeradio() {
      for (const s of this.eForm.source) {
        if (s === 1) {
          this.eForm.ishaveclient = 1
          let num = 0
          for (const c of this.eForm.client) {
            if (c === '色板') {
              num = 1
            }
          }
          if (num === 0) {
            this.eForm.client.push('色板')
            const _clientInfo = []
            for (const c of this.eForm.client) {
              _clientInfo.push({ name: c, type: 0, remark: '' })
            }
            this.eForm.clientInfo = _clientInfo
          }
        }
      }
      // 不包含厂部色板
      if (this.eForm.source.indexOf(0) === -1) {
        this.eImgList = []
        this.eForm.sids = []
      }
    },
    changeClient() {
      if (this.eForm.client.length > 0) {
        const _clientInfo = []
        for (const c of this.eForm.client) {
          _clientInfo.push({ name: c, type: 0, remark: '' })
        }
        this.eForm.clientInfo = _clientInfo
      } else {
        this.eForm.clientInfo = []
      }
    },
    changeType(val) {
      if (val === 3) {
        this.eRules.oldorderid[0].required = false
        this.eRules.beforenum[0].required = false
        this.eRules.beforeyear[0].required = false
      } else {
        this.eRules.oldorderid[0].required = true
        this.eRules.beforenum[0].required = true
        this.eRules.beforeyear[0].required = true
      }
    },
    getDealerInfoList() {
      getErpDealerList({ userid: this.user.dUserid }).then(response => {
        this.dealerInfo = response.data
      }).catch(() => {
        this.dealerInfo = []
      })
    },
    getCbList(query = '') {
      if (!this.eForm.bid) return;
      this.cbList = []
      this.cbLoading = true
      getColorBoardList({
        page: 1,
        limit: 9999,
        content: query,
        brandid: this.eForm.bid,
        seriesid: ''
      }).then(response => {
        this.cbList = response.data || []
        this.cbLoading = false
      }).catch(() => {
        this.cbList = []
        this.cbLoading = false
      })
    },
    setCb(values) {
      this.eImgList = []
      this.cbList.forEach(r => {
        if (values.indexOf(r.board_id) > -1) {
          this.eImgList.push({id: r.imgid, url: r.img_url})
        }
      })
      this.eRules.imgids[0].required = this.eImgList.length <= 0
    },
    setBid() {
      this.getCbList()
      this.eImgList = []
      this.eForm.sids = []
    },
    setDel() {
      this.orderLoad = new Date().getTime()
      this.eForm.oldorderid = ''
      this.eForm.beforenum = ''
      this.eForm.beforeyear = ''
      if (this.eForm.delid !== null && this.eForm.delid !== '') {
        getErpDealerBrandList({ delid: this.eForm.delid }).then(response => {
          this.brandInfo = response.data
          if (this.brandInfo.length > 0) {
            this.eForm.bid = this.brandInfo[0].bid
            // 清除已选色板
            this.getCbList()
            this.eImgList = []
            this.eForm.sids = []
          }
        }).catch(() => {
          this.brandInfo = []
          this.eForm.bid = null
        })

        if (this.dealerInfo && this.dealerInfo.length > 0) {
          const index = this.dealerInfo.findIndex(r => r.delid == this.eForm.delid)
          if (index > -1) {
            const craft = this.dealerInfo[index].craft
            this.eForm.nb = (craft == 1 || craft == 2) ? craft + '' : ''
          }
        }
      } else {
        this.brandInfo = []
        this.eForm.bid = null
      }
    },
    setOrder(data) {
      this.eForm.nature = data.nature
      this.eForm.custname = data.custname
      this.eForm.custtel = data.custtel
      this.eForm.address = data.address
      if (data.bid === 3) {
        this.eForm.beforenum = data.ordernum
      } else {
        this.eForm.beforenum = data.produnum
      }
      this.eForm.beforeyear = data.time.substring(0, 4)
      this.eForm.bid = data.bid
      this.eForm.designer = data.designer
      this.eForm.designerTel = data.designerTel
      this.eForm.source = []
    },
    openManual() {
      this.eForm.oldorderid = ''
      this.eForm.beforenum = ''
      this.eForm.beforeyear = ''
      this.isManual = true
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let clientInfo = ''
            if (this.eForm.ishaveclient === 1) {
              clientInfo = qs.parse(this.eForm.clientInfo)
            }
            let imgids = [...this.eForm.imgids]
            if (this.eImgList.length > 0) {
              this.eImgList.forEach(r => {
                imgids.push(r.id)
              })
            }
            const data = {
              clientInfo: clientInfo,
              replaceid: this.user.dUserid,
              delid: this.eForm.delid,
              type: this.eForm.type,
              nature: this.eForm.nature,
              oldorderid: this.eForm.oldorderid,
              beforenum: this.eForm.beforenum,
              beforeyear: this.eForm.beforeyear,
              custname: this.eForm.custname,
              custtel: this.eForm.custtel,
              address: this.eForm.address,
              exptime: this.eForm.exptime,
              designer: this.eForm.designer,
              designerTel: this.eForm.designerTel,
              estimated: this.eForm.estimated,
              bid: this.eForm.bid,
              nb: this.eForm.nb,
              mr: this.eForm.mr ? 1 : 0,
              fk: this.eForm.fk,
              source: this.eForm.source.join(','),
              sids: this.eForm.sids.join(','),
              remark: this.eForm.remark,
              fileids: this.eForm.files.join(','),
              imgids: imgids.join(',')
            }
            ErpOrderReplace(data).then(response => {
              this.editloading = false
              this.$message({
                message: '订单录入成功',
                type: 'success'
              })
              this.resetForm(formName)
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$refs['fileupload'].clearMultiFile()
      this.$refs['imgupload'].clearMultiImg()
      this.eForm.oldorderid = ''
      this.eForm.beforenum = ''
      this.eForm.beforeyear = ''
      this.eImgList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.dddl-container {

}
</style>
